/* @flow */

import moment from 'moment';

const getFiltroIntervaloDia = () => ({
    dataInicial: moment().format('Y-MM-DD'),
    dataFinal: moment().format('Y-MM-DD'),
    etapasId: 0,
});

export default getFiltroIntervaloDia;
